module.exports = __webpack_public_path__ + "static/media/agrs.5a283d97.svg";